

    if (window.Sentry) {
      window.Sentry.init({ dsn: "https://1eeb89147c984dc6bc3ffafd9e6cd089@sentry.wixpress.com/809", environment: 'Editor' });
    }
  

    import React from 'react';
    import ReactDOM from 'react-dom';
    import { withStyles } from '@wix/native-components-infra';
    import EditorAppWrapper from '@wix/yoshi-flow-editor/runtime/esm/EditorAppWrapper.js';
    import Widget from '/home/builduser/work/891961f4bce470b7/packages/wix-ricos-viewer-ooi/src/components/ricosviewer/Widget/index.tsx';
    import createController from '/home/builduser/work/891961f4bce470b7/packages/wix-ricos-viewer-ooi/src/components/ricosviewer/controller.ts';

    
import { createHttpClient } from '@wix/yoshi-flow-editor/runtime/esm/controller/httpClientProp';
    

    

  import { initI18nWithoutICU as initI18n } from '@wix/yoshi-flow-editor/runtime/esm/i18next/init';


    
const multilingualDisabled = false;

    
import { createExperiments, createWidgetExperiments } from '@wix/yoshi-flow-editor/runtime/esm/experiments';
    

    
import { createRavenClient } from '@wix/yoshi-flow-editor/error-monitor';
    import Raven from '@wix/yoshi-flow-editor/raven-js';
    var createErrorMonitor = function(options) {
      return createRavenClient({
        Raven,
        ...options,
      });
    };
    

    
import { I18nextProvider } from '@wix/yoshi-flow-editor/i18n';


      import { PureExperimentsProvider } from '@wix/yoshi-flow-editor';
      var ExperimentsProvider = React.Fragment;
      

import { BILoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/BILogger/BILoggerProvider';

import { PanoramaProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/PanoramaProvider';

import { FedopsLoggerProvider } from '@wix/yoshi-flow-editor/runtime/esm/react/FedopsLoggerProvider';

import { HttpProvider } from '@wix/yoshi-flow-editor';

import { TPAComponentsProvider } from 'wix-ui-tpa';

import { BaseUiEnvironmentProviderWrapper } from '@wix/yoshi-flow-editor/runtime/esm/react/BaseUiEnvironmentProviderWrapper';

var providers = {
  I18nextProvider,
  ExperimentsProvider,
  PureExperimentsProvider,
  BILoggerProvider,
  FedopsLoggerProvider,
  PanoramaProvider,
  HttpProvider,
  TPAComponentsProvider,
  BaseUiEnvironmentProviderWrapper,
}

    import * as fedopsLogger from '@wix/yoshi-flow-editor/fedops';

    
  var importedApp = {};

    var componentName = 'ricosviewer';
    var projectName = 'ricos-viewer-ooi';
    var sentryConfig = {
      DSN: 'https://1eeb89147c984dc6bc3ffafd9e6cd089@sentry.wixpress.com/809',
      id: '1eeb89147c984dc6bc3ffafd9e6cd089',
      projectName: 'ricos-viewer-ooi',
      teamName: 'ricos',
      errorMonitor: true,
    };
    

    import * as usersStyleParamsEntry from '/home/builduser/work/891961f4bce470b7/packages/wix-ricos-viewer-ooi/src/components/ricosviewer/stylesParams.ts';
var stylesParamsEntry = usersStyleParamsEntry;
var stylesParams = stylesParamsEntry.default;
var customCssVars = stylesParamsEntry.customCssVars || function() { return {} };
    


    var experimentsConfig = {"centralized":true,"scopes":["ricos"]};
    var fedopsConfig = null;
    var translationsConfig = {"icuEnabled":false,"defaultTranslationsPath":"/home/builduser/work/891961f4bce470b7/packages/wix-ricos-viewer-ooi/src/assets/locales/messages_en.json","availableLanguages":["ar","bg","ca","cs","da","de","el","en","es","fi","fr","he","hi","hr","hu","id","it","ja","ko","lt","lv","ms","nl","no","pl","pt","ro","ru","sk","sl","sv","th","tl","tr","uk","vi","zh"]};
    var defaultTranslations = {"app.name":"Rich Content","app.gfpp.connectToData":"Connect to CMS","app.gfpp.editContent":"Edit Content","app.content.emptyStateTitle":"Connect to CMS to show rich content","app.content.emptyStateLabel":"Choose a Rich Content field from your CMS collection to show its content here.","app.settings.tabs.main":"Main","app.settings.tabs.design":"Design","app.settings.tabs.display":"Display","app.settings.tabs.settings":"Settings","app.settings.tabs.support":"Support","app.settings.tabs.main.editContentDescription":"Edit Rich Content from your Collection to display it on your site.","app.settings.tabs.main.editContentButton":"Edit Content","app.settings.tabs.design.background":"Background","app.settings.tabs.design.texts":"Texts","app.settings.tabs.design.buttonLinks":"Button & Links","app.settings.tabs.design.backButton":"Back","app.settings.tabs.design.background.backgroundSection":"Background","app.settings.tabs.design.background.backgroundSection.fillColorPickerTitle":"Fill color & opacity","app.settings.tabs.design.background.backgroundSection.paddingsTopBottomSlider":"Top & bottom paddings","app.settings.tabs.design.background.backgroundSection.paddingsLeftRightSlider":"Left & right paddings","app.settings.tabs.design.background.backgroundSection.cornerRadiusSlider":"Corner radius","app.settings.tabs.design.background.borderSection":"Border","app.settings.tabs.design.background.borderSection.borderColorPickerTitle":"Border color & opacity","app.settings.tabs.design.background.borderSection.borderSlider":"Border width","app.settings.tabs.design.texts.headingsSection":"Headings","app.settings.tabs.design.texts.headingsSection.h1":"Heading 1 style & color","app.settings.tabs.design.texts.headingsSection.h2":"Heading 2 style & color","app.settings.tabs.design.texts.headingsSection.h3":"Heading 3 style & color","app.settings.tabs.design.texts.headingsSection.h4":"Heading 4 style & color","app.settings.tabs.design.texts.headingsSection.h5":"Heading 5 style & color","app.settings.tabs.design.texts.headingsSection.h6":"Heading 6 style & color","app.settings.mobile.tabs.design.texts.headingsSection.h1":"Heading 1 (H1) font size","app.settings.mobile.tabs.design.texts.headingsSection.h2":"Heading 2 (H2) font size","app.settings.mobile.tabs.design.texts.headingsSection.h3":"Heading 3 (H3) font size","app.settings.mobile.tabs.design.texts.headingsSection.h4":"Heading 4 (H4) font size","app.settings.mobile.tabs.design.texts.headingsSection.h5":"Heading 5 (H5) font size","app.settings.mobile.tabs.design.texts.headingsSection.h6":"Heading 6 (H6) font size","app.settings.tabs.design.texts.headingsSection.headingOptions":"More heading options","app.settings.tabs.design.texts.paragraphSection":"Paragraph","app.settings.mobile.tabs.design.texts.paragraphSection":"Text Size","app.settings.tabs.design.texts.paragraphSection.p":"Text style & color","app.settings.mobile.tabs.design.texts.paragraphSection.p":"Paragraph font size","app.settings.tabs.design.texts.paragraphSection.quote":"Quote text size & color","app.settings.mobile.tabs.design.texts.paragraphSection.quote":"Quote font size","app.settings.tabs.design.buttonLinks.buttonSection":"Button Style","app.settings.tabs.design.buttonLinks.buttonSection.defaultTab":"Default","app.settings.tabs.design.buttonLinks.buttonSection.hoverTab":"Hover","app.settings.tabs.design.buttonLinks.buttonSection.styleThumbnailButtonGroup":"Choose a style","app.settings.tabs.design.buttonLinks.buttonSection.textColorPickerTitle":"Text color","app.settings.tabs.design.buttonLinks.buttonSection.backgroundColorPickerTitle":"Background color & opacity","app.settings.tabs.design.buttonLinks.buttonSection.borderColorPickerTitle":"Border color & opacity","app.settings.tabs.design.buttonLinks.buttonSection.borderSlider":"Border width","app.settings.tabs.design.buttonLinks.buttonSection.cornerRadiusSlider":"Corner radius","app.settings.tabs.design.buttonLinks.linkSection":"Link Style","app.settings.tabs.design.buttonLinks.linkSection.linkHashtagColorPickerTitle":"Links & hashtags color","app.settings.tabs.display.displayContent.info.text":"Shortening the content may be useful when using repeaters. ","app.settings.tabs.display.displayContent.info.linkText":"Learn more","app.settings.tabs.display.displayContent.label":"What will your visitors see? ","app.settings.tabs.display.displayContent.allContent":"All the content","app.settings.tabs.display.displayContent.shortenedContent":"Shortened content","app.settings.tabs.display.displayContent.withExpand":"Collapsible content","app.settings.tabs.display.blocksToShow":"Blocks to show","app.settings.tabs.display.blocksToShow.info":"A block can be a text paragraph or a rich content element.","app.settings.tabs.display.sectionPerHeightToggle":"Set section height","app.settings.tabs.app.settings.tabs.display.sectionHeightSliderTitle":"Section height (px)","app.settings.tabs.display.labelForExpand":"Write a label to expand the content","app.settings.tabs.display.labelForExpand.expandButtonLabel":"Read more...","app.settings.tabs.display.labelForCollapse":"Write a label to collapse the content","app.settings.tabs.display.labelForCollapse.collapseButtonLabel":"Read less...","app.settings.tabs.settings.previewToggle":"Preview mode","app.settings.tabs.design.reset":"Reset To Original Design","app.settings.tabs.support.questionSection":"Got a Question?","app.settings.tabs.support.questionSection.richContentHelp":"Wix Rich Content help","app.settings.tabs.support.questionSection.customerCare":"Contact Customer Care"};
    var styleHocConfig = {"enabled":true};
    var biConfig = null;
    var appDefinitionId = "949cfcc9-2a3f-4a96-bd6c-11d9d82763a4";
    var componentId = "aa86b56d-3c49-44fd-9976-963695e7815d";
    var localeDistPath = 'assets/locales';
    var persistentAcrossPages = false;
    var shouldUseEssentials = true;
    var shouldSkipMultipleRendersAfterViewModeChange = false;
    var withErrorBoundary = false;

    import { createVisitorBILogger as biLogger } from '/home/builduser/work/891961f4bce470b7/packages/wix-ricos-viewer-ooi/target/generated/bi/createBILogger.ts';
    
      import { hot } from '@wix/component-hot-loader';
      var UserComponent = hot(module, Widget);
    

    var EditorComponent = React.createElement(EditorAppWrapper, {
      UserComponent,
      appDefinitionId,
      componentId,
      name: componentName,
      sentryConfig: sentryConfig,
      styleHocConfig: styleHocConfig,
      experimentsConfig: experimentsConfig,
      fedopsConfig: fedopsConfig,
      multilingualDisabled,
      translationsConfig: translationsConfig,
      defaultTranslations: defaultTranslations,
      shouldUseEssentials,
      persistentAcrossPages,
      projectName: projectName,
      biConfig: biConfig,
      biLogger: biLogger,
      stylesParams,
      customCssVars,
      withErrorBoundary,
      shouldSkipMultipleRendersAfterViewModeChange,
      userController: createController,
      customInitAppForPage: importedApp.initAppForPage,
      optionalDeps: {
        initI18n,
        fedopsLogger,
        withStylesHoc: withStyles,
        createHttpClient,
        createExperiments,
        createWidgetExperiments,
        createErrorMonitor,
        providers,
      },
      localeDistPath: localeDistPath,
    });
    ReactDOM.render(EditorComponent, document.getElementById('root'));
